import { makeStyles, fade } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles((theme) => ({
	inputBase: {
		padding: 10,
		width: "100%",
		borderBottom: `1px solid ${colors.blue[200]}`,
		"& input": {
			borderRadius: 4,
			...ColorUtil.getBackgroundAndContrastColor(theme.palette.common.white),
			padding: 8,
			transition: theme.transitions.create(["border-color", "box-shadow"]),
			border: `1px solid ${colors.blue[200]}`,
			fontSize: 14,
			"&:focus": {
				boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
				borderColor: theme.palette.primary.main
			}
		}
	},
	close: {
		opacity: 0.6,
		width: 18,
		height: 18
	},
	text: {
		flexGrow: 1
	},
	iconSelected: {
		width: 17,
		height: 17,
		marginRight: 5,
		marginLeft: -2
	},
	closeIcon: {
		float: "right",
		"& svg": {
			fontSize: "1rem"
		}
	},
	tagsCard: {
		marginTop: theme.spacing(1),
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		paddingBottom: theme.spacing(3),
		maxWidth: "400px"
	},
	color: {
		width: 14,
		height: 14,
		flexShrink: 0,
		borderRadius: 3,
		marginRight: 8,
		marginTop: 2
	},
	popperDisablePortal: {
		position: "relative"
	},
	option: {
		minHeight: "auto",
		alignItems: "flex-start",
		padding: 8,
		"&[aria-selected='true']": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		},
		"&[data-focus='true']": {
			...ColorUtil.getBackgroundAndContrastColor(theme.palette.action.hover)
		}
	},
	paper: {
		boxShadow: "none",
		margin: 0,
		color: colors.blue[900],
		fontSize: 13
	},
	popper: {
		border: "1px solid rgba(27,31,35,.15)",
		boxShadow: "0 3px 12px rgba(27,31,35,.15)",
		borderRadius: 3,
		width: 300,
		zIndex: 9999999,
		fontSize: 13,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[50])
	},
	loadingTagAction: {
		color: colors.gray[0]
	},
	pluginFeatureIconCircle: {
		width: 19,
		height: 19,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
		borderRadius: "50%"
	},
	tagCard: {
		borderRadius: 22,
		height: theme.spacing(3),
		width: "98%",
		fontSize: 15,
		marginBottom: theme.spacing(1),
		color: "white",
		display: "flex",
		alignItems: "center"
	},
	pluginFeatureIcon: {
		width: "16px",
		height: "16px"
	},
	tagName: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "-webkit-box",
		"-webkit-line-clamp": 1,
		"-webkit-box-orient": "vertical"
	}
}))

export default useStyles
